import {SupabaseInstance} from '../utils';

export type DefaultCreateDataT = {
  created_by: string;
  modified_by: string;
  date_created: string;
  date_modified: string;
};

/**
 * This function is used to create the data in the database.
 * @returns {Promise<DefaultCreateDataT>} - The created data.
 */
export const defaultCreateData = async (): Promise<DefaultCreateDataT> => {
  const {id} = await SupabaseInstance.getCurrentUser();
  const timestamp = new Date().toISOString();

  return {
    created_by: id,
    modified_by: id,
    date_created: timestamp,
    date_modified: timestamp,
  };
};
